import React from 'react';
import { Route, HashRouter as Router } from 'react-router-dom';
import { createStore } from "redux";
import { Provider } from 'react-redux';
import reducer from "./redux/reducers";
import { theme } from "./AppTheme";
import { ThemeProvider } from '@material-ui/core/styles';

import LoginScreen from './components/screens/public/user/login';
import RegisterScreen from './components/screens/public/user/register';
import ForgotPasswordScreen from './components/screens/public/user/forgot-password';
import ResetPasswordScreen from './components/screens/public/user/reset-password';
import ConfirmEmailScreen from './components/screens/public/user/confirm-email';
import DashboardScreen from './components/screens/private/user/dashboard';
import ChangePasswordScreen from './components/screens/private/user/change-password';
import UpdateProfileScreen from './components/screens/private/user/update-profile';
import RMAConfigsScreen from './components/screens/private/user/rma-configs';
import LogoutScreen from './components/screens/private/user/logout';
import SubscriptionStatusScreen from './components/screens/private/subscription/subscription-status';
import PaymentsScreen from './components/screens/private/subscription/payments';
import OrdersScreen from './components/screens/private/content/orders';
import OrdersAddScreen from './components/screens/private/content/orders/add';
import OrdersEditScreen from './components/screens/private/content/orders/edit';

window.reduxStore = createStore(reducer);

export const routing = (
    <ThemeProvider theme={theme}>
        <Provider store={window.reduxStore}>
            <Router>
                <div>
                    <Route path="/" component={DashboardScreen} exact />
                    <Route path="/user/login" component={LoginScreen} />
                    <Route path="/user/register" component={RegisterScreen} />
                    <Route path="/user/forgot-password/:email?" component={ForgotPasswordScreen} />
                    <Route path="/user/reset-password/:email?/:code?" component={ResetPasswordScreen} />
                    <Route path="/user/confirm-email/:email?/:code?" component={ConfirmEmailScreen} />
                    <Route path="/user/change-password" component={ChangePasswordScreen} />
                    <Route path="/user/update-profile" component={UpdateProfileScreen} />
                    <Route path="/user/logout" component={LogoutScreen} />

                    <Route path="/content/orders" component={OrdersScreen} exact />
                    <Route path="/content/orders/add" component={OrdersAddScreen} />
                    <Route path="/content/orders/edit/:id" component={OrdersEditScreen} />

                    <Route path="/user/rma-configs" component={RMAConfigsScreen} />
                    <Route path="/subscription/current-status" component={SubscriptionStatusScreen} />
                    <Route path="/subscription/payments" component={PaymentsScreen} />

                </div>
            </Router>
        </Provider>
    </ThemeProvider>
);
